import { cn } from '~shared/utils/cn'
import phone from './images/phone.png'
import handsSign from './images/hands-background.png'
import avatar1 from './images/Avatar1.png'
import avatar2 from './images/Avatar2.png'

const messages = [
  {
    id: 1,
    text: 'Здравствуйте, Анна! Подскажите, пожалуйста, где посмотреть тайминг обучения, до какого числа необходимо пройти темы',
    avatarSrc: avatar1.src
  },
  {
    id: 2,
    text: 'Весь этот модуль предполагается на 2 месяца, то есть дедлайны по сдаче заданий - 20 мая. Так будет комфортнее идти дальше, изучив всю информацию и выполнив задания',
    avatarSrc: avatar2.src
  },
  {
    id: 3,
    text: 'Спасибо большое!',
    avatarSrc: avatar1.src
  }
]

const testimonials = [
  'В киноклубах вы сможете анализировать фильмы с точки зрения психологии и обсуждать их с коллегами',
  'Во время практики преподаватели и <span style="color: #7D5EE4;">супервизоры</span> будут отслеживать динамику и прогресс в обучении',
  'Куратор будет сопровождать вас на протяжении всего обучения, помогая решить возникающие вопросы'
]

const TestimonialCard = ({ text }: { text: string }) => (
  <div
    className={cn(
      'flex p-[24px_14px_24px_14px] 2lg:p-[24px] gap-[12px] bg-white rounded-[16px]',
    )}>
    <div className='w-[8px] h-[8px] bg-black rounded-full shrink-0 translate-y-[5px]' />
    <p
      className='2lg:text-[20px]/[120%] text-[16px]/[120%]'
      dangerouslySetInnerHTML={{ __html: text }}
    />
  </div>
)

const Message = ({
  isIncoming,
  avatarSrc,
  text
}: {
  isIncoming: boolean
  avatarSrc: string
  text: string
}) => (
  <div
    className={cn(
      'flex gap-[10px] items-end justify-start',
      isIncoming ? 'flex-row' : 'flex-row-reverse',
      'md:gap-[8px]',
      'sm:gap-[6px]'
    )}>
    <img
      src={avatarSrc}
      alt=''
      className={cn(
        'mb-[2px] w-[36px] h-[36px] rounded-full object-cover shrink-0',
        'xl:mb-0'
      )}
    />
    <div
      className={cn(
        '2lg:p-[11px] rounded-[15px] p-[10px]',
        isIncoming
          ? 'bg-[var(--eta)] text-[var(--alpha)] max-w-[235px] 2lg:max-w-[212px] md:max-w-[200px] sm:max-w-[200px]'
          : 'bg-[var(--alpha)] text-[var(--omega)] max-w-[213px] 2lg:max-w-[191px] md:max-w-[200px] sm:max-w-[200px]',
        'sm:rounded-[11px]'
      )}>
      {text}
    </div>
  </div>
)

const Bell = ({ className }: { className?: string }) => (
  <div
    className={cn(
      'rounded-full w-[32px] h-[32px] bg-white grid place-items-center shrink-0',
      className
    )}>
    <svg
      width='16'
      height='17'
      viewBox='0 0 16 17'
      fill='none'
      xmlns='http://www.w3.org/2000/svg'>
      <path
        d='M1.96633 13.547H14.0368C14.7526 13.547 15.1867 13.1814 15.1867 12.6255C15.1867 11.864 14.41 11.1786 13.755 10.5008C13.2524 9.97539 13.1153 8.89397 13.0544 8.01817C13.0011 5.09387 12.2243 3.0834 10.1986 2.35232C9.90923 1.3547 9.12486 0.570312 7.99776 0.570312C6.87828 0.570312 6.08628 1.3547 5.80451 2.35232C3.7788 3.0834 3.00203 5.09387 2.94872 8.01817C2.8878 8.89397 2.75072 9.97539 2.2481 10.5008C1.58556 11.1786 0.816406 11.864 0.816406 12.6255C0.816406 13.1814 1.24287 13.547 1.96633 13.547ZM7.99776 16.6008C9.29239 16.6008 10.2367 15.6564 10.3357 14.5903H5.66743C5.76643 15.6564 6.71074 16.6008 7.99776 16.6008Z'
        fill='#1C1C1E'
      />
    </svg>
  </div>
)

const Notification = () => (
  <div
    className={cn(
      'relative z-[1] p-[22px_16px_16px] rounded-[15px] bg-white mt-[15px] 2lg:mt-[114px] mb-[16px]',
      'text-center',
      'xl:p-[18px_12px_12px]',
      'sm:p-[18px_11px_9px]'
    )}>
    <Bell className='absolute top-[-12px] left-1/2 -translate-x-1/2' />
    <span>В Telegram-чате можно общаться</span>
    <br />
    <span>
      с менторами и другими участниками, задавать вопросы, обсуждать задания
    </span>
  </div>
)

export const CommunitySupportSection = () => {
  return (
    <section id='community-support' className='py-[80px]'>
      <div className='mx-auto px-[16px] box-border max-w-[672px] md:max-w-[864px] 2lg:max-w-[1280px]'>
        <div
          className={cn(
            'rounded-[16px] px-[16px] md:px-[32px] pt-[32px] 2lg:px-[80px] 2lg:pt-[80px] overflow-hidden',
            'flex flex-col'
          )}
          style={{
            backgroundImage: `url(${handsSign.src})`,
            backgroundSize: 'cover',
            backgroundPosition: 'center'
          }}>
          <h2 className='text-[40px] 2lg:text-[48px] text-white max-w-[600px] mb-[24px]'>
            Поддержка и комьюнити для участников курса
          </h2>

         <div className='flex gap-[16px] flex-col justify-between md:flex-row '>
            <div
              className={cn(
                'flex flex-col gap-[16px] 2lg:mb-[80px] mb-[32px]',
                'md:gap-[14px]',
                'lg:gap-[16px] md:max-w-[50%] lg:max-w-[400px] 2lg:max-w-[475px]',
              )}>
              {testimonials.map((text, index) => (
                <TestimonialCard text={text} key={index} />
              ))}
            </div>
  
            <div
              className={cn(
                'flex flex-col  max-w-[344px] mx-auto px-[32px] pt-[60px] 2lg:pt-[70px] text-[10px]/[120%]',
                '2lg:text-[11px]/[120%] 2lg:max-w-[400px] 2lg:mt-[-100px]',
                ''
              )}
              style={{
                backgroundImage: `url(${phone.src})`,
                backgroundSize: 'cover',
                backgroundRepeat: 'no-repeat'
              }}>
              <div
                className={cn(
                  'flex flex-col w-full gap-[5px] z-[1]',
                  'md:gap-[8px]',
                  'lg:gap-[6px]',
                  'xl:gap-[4px]'
                )}>
                {messages.map((message, index) => (
                  <Message
                    isIncoming={index % 2 !== 0}
                    avatarSrc={message.avatarSrc}
                    text={message.text}
                    key={message.id}
                  />
                ))}
              </div>
              <Notification />
            </div>
         </div>
        </div>
      </div>
    </section>
  )
}
